import { render, staticRenderFns } from "./VerifyMessageContainer.vue?vue&type=template&id=b2e477c8&scoped=true&"
import script from "./VerifyMessageContainer.vue?vue&type=script&lang=js&"
export * from "./VerifyMessageContainer.vue?vue&type=script&lang=js&"
import style0 from "./VerifyMessageContainer.vue?vue&type=style&index=0&id=b2e477c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e477c8",
  null
  
)

export default component.exports